
import { getLatLng } from './lbsutils/getLocatioNew';
import { getZufangPositionCity } from '../api'

const defaultCity = {
    cityName: '北京',
    cityId: 1,
    open: false,
    isPositionSucc: false,
    lat: '',
    lon: ''
};

const timeout = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(defaultCity);
        }, 5000);
    });
};

const fetchCurrentCity = () => {
    return new Promise((resolve) => {
        getLatLng().then(lbs => {
            const params = lbs;
            if (params.lat + '' === '0' || params.lng + '' === '0') {
                return resolve(defaultCity);
            }

            getZufangPositionCity({addressLat:lbs.lat,addressLon: lbs.lng}).then((res) => {
                const { code, success, cityId, cityName, open } = res
                if (code == 0 && success) {
                    const cityInfo = {
                        isPositionSucc: true,
                        cityId,
                        cityName,
                        open,
                        lat: lbs.lat,
                        lon: lbs.lng
                    }
                    return resolve(cityInfo);
                } else {
                    return resolve(defaultCity);
                }
            })
            .catch((err) => {
                console.log('地址请求错误,', err);
                resolve(defaultCity);
            });
        }).catch((e) => {
            console.log('获取经纬度失败', e);
            resolve(defaultCity);
        });
    });
};

const getCurrentCity = () => {
    return Promise.race([timeout(), fetchCurrentCity()]);
};

export default getCurrentCity;
